import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { IRiskCategory } from './riskCategory.models';

export const apiRoutes = {
  getAllRiskCategories: '/RiskCategories',
};

export const getAllRiskCategoriesAsync = createGetOptionsNoPropsFn<IRiskCategory>(apiRoutes.getAllRiskCategories);
